// extracted by mini-css-extract-plugin
export default {"main":"Home_main__4+rG5","cta":"Home_cta__q9ctZ","preview":"Home_preview__QB16C"};